import { useContext } from "react";
import PropTypes from "prop-types";

// @mui material components
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewUser page components
import FormField from "components/FormField";
import { CrudCompanyContext } from "context/CrudCompanyContext";

export default function CompanyInfo({ formData }) {
  const { notifyNewAccountsCheckbox, setChecked } = useContext(CrudCompanyContext)
  const { formField, values, errors, touched } = formData;
  const { name, CNPJ, employer_code, } = formField;
  const { name: nameV, CNPJ: CNPJV, employer_code: employerCodeV } = values;

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">Sobre a companhia</MDTypography>
        <MDTypography variant="button" color="text">
          Informações obrigatórias
        </MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <FormField
          type={name.type}
          label={name.label}
          name={name.name}
          value={nameV}
          placeholder={name.placeholder}
          error={errors.name && touched.name}
          success={nameV.length > 0 && !errors.name}
        />
        <FormField
          type={CNPJ.type}
          label={CNPJ.label}
          name={CNPJ.name}
          value={CNPJV}
          mask={CNPJ.mask}
          placeholder={CNPJ.placeholder}
          error={errors.CNPJ && touched.CNPJ}
          success={CNPJV.length > 0 && !errors.CNPJ}
        />
        <FormField
          type={employer_code.type}
          label={employer_code.label}
          name={employer_code.name}
          value={employerCodeV}
          mask={employer_code.mask}
          placeholder={employer_code.placeholder}
          error={errors.employer_code && touched.employer_code}
          success={employerCodeV.length > 0 && !errors.employer_code}
        />
        <Grid container >
          <Grid item >
            <Checkbox
              checked={notifyNewAccountsCheckbox}
              onChange={() => {
                setChecked()
              }}
            />
          </Grid>
          <Grid item >
            <MDTypography
              pt
              fontSize="1rem"
            >
              Notificar criação de contas de colaboradores
            </MDTypography>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

// typechecking props for CompanyInfo
CompanyInfo.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};